import RentalDate from "./views/date/date";
import RentalInsurance from "./views/insurance/insurance";
import RentalVehicle from "./views/vehicle/vehicle";
import RentalAccessories from "./views/accessories/accessories";
import RentalSummary from "./views/summary/summary";
import RentalPrivate from "./views/private/private";
import RentalTabs from "./views/tabs/tabs";
import {gsap} from "gsap";
import RentalAccordion from "./views/accordion/RentalAccordion";
import VehicleDetail from "../rental_vehicles/views/CarPark/Detail/VehicleDetail";
import VehicleSimilar from "../rental_vehicles/views/similar/similar";

const Rental = {

    init() {
        this.el = $('[page="reservation"][module="rental"]');
        if (!this.el.length) return;

        this.wrapper = this.el.filter('.wrapper');
        RentalTabs.init();
        RentalPrivate.init();
        RentalAccordion.init();
        this.initComponents(true);
        this.bind();
    },

    Footer: {
        init(el) {
            this.el = el.find('.footer');

            this.next = this.el.find('.next');
            this.back = this.el.find('.back');

            this.bind();
        },

        bind() {
            this.next.on('click', (evt) => this.goNext(evt));
            this.back.on('click', (evt) => this.goBack(evt));

            window.addEventListener('keydown', (event) => {
                if (event.key === 'ArrowLeft') {
                    this.back.trigger("click");
                } else if (event.key === 'ArrowRight') {
                    this.next.trigger("click");
                }
            });
        },
        goNext(evt) {
            const hash = rentalHash ? `?hash=${rentalHash}` : ''
            const url = "/" + window.T.rental.base_url + "/" + $(evt.currentTarget).attr('url');
            Rental.load(url, null, 1);
            history.pushState({url: url, direction: 1}, '', url + hash)
        },

        goBack(evt) {
            const hash = rentalHash ? `?hash=${rentalHash}` : ''
            const url = "/" + window.T.rental.base_url + "/" + $(evt.currentTarget).attr('url');
            Rental.load(url, null, -1);
            history.pushState({url: url, direction: -1}, '', url + hash)
        },
    },

    initComponents(animate) {
        this.setHash();
        RentalDate.init(animate)
        RentalInsurance.init(animate)
        RentalVehicle.init(animate)
        RentalAccessories.init(animate)
        RentalSummary.init(animate);
        VehicleDetail.init(animate);
        VehicleSimilar.init();

        this.Footer.init(this.el);
    },

    setHash() {
        let url = new URL(window.location);
        let params = new URLSearchParams(url.search);

        if (typeof rentalHash === 'string' && !params.get('hash')) {
            params.append("hash", rentalHash);
            history.replaceState({}, '', '?' + params)
        }
    },

    bind() {
        window.addEventListener('popstate', (event) => {
            Rental.load(event.state.url, null, event.state.direction)
        })
    },

    load(url, data, direction = undefined) {
        this.direction = direction;
        url = url || this.currentUrl();
        this.url = url;

        const hash = rentalHash ? `&hash=${rentalHash}` : ''
        const page_id = window.ID_PAGE

        return $.ajax({
            type: 'POST',
            url: `/modules/rental/rental.async.php?go=${url}${hash}&page_id=${page_id}`,
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'html',
            success: (response) => {
                this.afterLoad(response);
            },
            error: (xhr, status, error) => {
                console.error('Error:', error);
            }
        })
    },

    afterLoad(response) {
        this.wrapper.find('[load]').removeAttr('load');
        this.replaceTabs(response);
        this.replacePrivateLine(response);

        if (this.direction !== undefined) {
            if (window.innerWidth <= 740) {
                RentalAccordion.setActive(this.url, this.direction, response);
                this.initComponents(this.direction);
            } else {
                this.replaceContent(response);
            }
        }
    },

    replaceTabs(response) {
        let html = $('<div>').hide().empty().html(response);
        const tabs = html.find('[view="tabs"] .dragger .holder .tab');
        const tabHolder = this.el.filter('[view="tabs"]').find('.dragger .holder');
        tabHolder.empty().append(tabs);
        RentalTabs.bind();
        RentalTabs.show();
        RentalTabs.setCurrent(this.url);
        RentalAccordion.updateData();
    },

    replacePrivateLine(response) {
        let html = $('<div>').hide().empty().html(response);
        const privateLine = html.find('section.Private [container]');
        const privateHolder = $('.Private');

        privateHolder.empty().append(privateLine);
        RentalPrivate.init();
    },

    replaceContent(response) {
        let html = $('<div>').hide().empty().html(response);
        let wrapperClass = html.find('.wrapper').attr("class");

        const oldSection = this.wrapper.find('[module="rental"][section]')
        const newSection = html.find('[module="rental"][section]')
            .css({position: 'absolute', transform: 'translateX(' + (this.direction * 100) + '%)'})
            .appendTo(this.wrapper);

        $('[module="rental"].wrapper').attr("class", wrapperClass);

        gsap.timeline({
            onComplete: () => {
                oldSection.remove();
                AOS.refresh();
            }
        })
            .to(oldSection, {x: (-this.direction * 100) + '%', position: 'absolute'}, 0)
            .to(newSection, {x: 0, position: 'relative', clearProps: true}, 0)

        this.initComponents(this.direction);
    },

    currentUrl() {
        return $('[view="tabs"] .tab.active').attr('href')
    },

    inflect(subject, count) {
        if (count === 0) return window.T["rental"][subject + "0"];
        if (count === 1) return window.T["rental"][subject + "1"];
        if (count > 1 && count < 5) return window.T["rental"][subject + "2"];

        return window.T["rental"][subject + "5"];
    },

    afterSubmit(form, response) {
        RentalSummary.showThankYou(response);
    },

    resize() {
        // RentalTabs.resize()
    },

    isAdmin() {
        return Rental.el.is(".admin");
    }
}

export default Rental

window.Rental = Rental;